// src/App.js
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme/theme";
import Toast from "./components/common/Toast";

// 랜딩 페이지
import CompanyIntroPage from "./pages/CompanyIntroPage";
import ContactPage from "./pages/ContactPage";
import EcoPickPage from "./pages/EcoPickPage";
import DreamPage from "./pages/DreamPage";
import DreamDownloadPage from "./pages/DreamDownloadPage";
import MainLayout from "./components/MainLayout";

// 관리자 페이지
import LoginPage from "./pages/admin/LoginPage";
import ProtectedRoute from "./components/admin/ProtectedRoute";
import AdminPage from "./pages/admin/AdminPage";
import DashboardPage from "./pages/admin/DashboardPage";
import UserManagementPage from "./pages/admin/UserManagementPage";
import LocationManagementPage from "./pages/admin/LocationManagementPage";
import CollectionManagementPage from "./pages/admin/CollectionManagementPage";
import DreamUserManagementPage from "./pages/admin/DreamUserManagementPage";
import ReportPage from "./pages/admin/ReportPage";
import CustomerVoicePage from "./pages/admin/CustomerVoicePage";
import AdminActionLogPage from "./pages/admin/AdminActionLogPage";
import {
  DreamAdminIndexRedirect,
  DreamCollectorWorkPage,
  DreamCollectorsPage,
  DreamInspectionPage,
  DreamItemsPage,
  DreamMatchingPage,
  DreamOperationsPage,
  DreamReportsPage,
  DreamRequestsPage,
  DreamSchedulePage,
} from "./pages/admin/dream/DreamAdminPages";

import "./styles/global.css";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          {/* 그룹 1: 헤더가 있는 공개 페이지 */}
          <Route element={<MainLayout />}>
            <Route path="/" element={<CompanyIntroPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/ecopick" element={<EcoPickPage />} />
            <Route path="/dream" element={<DreamPage />} />
          </Route>

          {/* QR 코드용 앱 다운로드 페이지 */}
          <Route path="/dream/download" element={<DreamDownloadPage />} />

          {/* 그룹 2: 로그인 페이지 */}
          <Route path="/login" element={<LoginPage />} />

          {/* 그룹 3: 보호된 관리자 페이지 */}
          <Route element={<ProtectedRoute />}>
            <Route path="/admin" element={<AdminPage />}>
              <Route index element={<DashboardPage />} />
              <Route path="users" element={<UserManagementPage />} />
              <Route path="locations" element={<LocationManagementPage />} />
              <Route path="collections" element={<CollectionManagementPage />} />
              <Route path="dream-users" element={<DreamUserManagementPage />} />
              <Route path="market" element={<Navigate to="/admin/dream/operations" replace />} />
              <Route path="dream" element={<DreamAdminIndexRedirect />} />
              <Route path="dream/operations" element={<DreamOperationsPage />} />
              <Route path="dream/requests" element={<DreamRequestsPage />} />
              <Route path="dream/matching" element={<DreamMatchingPage />} />
              <Route path="dream/collectors" element={<DreamCollectorsPage />} />
              <Route path="dream/collector-work" element={<DreamCollectorWorkPage />} />
              <Route path="dream/schedule" element={<DreamSchedulePage />} />
              <Route path="dream/inspection" element={<DreamInspectionPage />} />
              <Route path="dream/items" element={<DreamItemsPage />} />
              <Route path="dream/reports" element={<DreamReportsPage />} />
              <Route path="dream/action-logs" element={<AdminActionLogPage />} />
              <Route path="customer-voice" element={<CustomerVoicePage />} />
              <Route path="reports" element={<ReportPage />} />
            </Route>
          </Route>
        </Routes>
      </Router>
      <Toast />
    </ThemeProvider>
  );
}

export default App;
